export const GAM_OS = {
  501012: "ios",
  501013: "android",
};
